
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" appendTo="body"></p-confirmDialog>
<p-accordion value="0">
  <p-accordion-panel value="0">
    <p-accordion-header id="Accordianclass" >Maintenance Actions</p-accordion-header>
    <p-accordion-content>
    <p-tabs value="1" class="table-view-class" (valueChange)="onTabChange($event)">
    <p-tablist>
    <p-tab value="1">Call Restore</p-tab>
    <p-tab value="2">Call Recon</p-tab>
    <p-tab value="3">Call Analytics</p-tab>
    <p-tab value="4">Call Finra Description</p-tab>
    <p-tab value="5">Call Comparative Review</p-tab>
    <p-tab value="6">Comparative Review Setup</p-tab>
     </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="1">
        <app-file-actions [fileProcessingType]="fileProcessingType"></app-file-actions>
      </p-tabpanel>
      <p-tabpanel value="2">
        <app-file-actions [fileProcessingType]="fileProcessingType"></app-file-actions>
      </p-tabpanel>
      <p-tabpanel value="3">
        <app-file-actions [fileProcessingType]="fileProcessingType"></app-file-actions>
      </p-tabpanel>
      <p-tabpanel value="4">
        <app-file-actions [fileProcessingType]="fileProcessingType"></app-file-actions>
      </p-tabpanel>
      <p-tabpanel value="5">
        <app-file-actions [fileProcessingType]="fileProcessingType"></app-file-actions>
      </p-tabpanel>
       @if((userService.isRoleSuperUser() || userService.isRoleFirmAdmin())){
      <p-tabpanel value="6"> 
        <app-comparative-review-setup></app-comparative-review-setup>
      </p-tabpanel>
    }
      </p-tabpanels>
    </p-tabs>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>